import { FONTS } from '../../../config/app-config';
// src/components/navigation/header/VersionSelector.js
import React, { useState } from 'react';
import { Box, Typography, Menu, MenuItem, Tooltip } from '@mui/material';
import RestoreIcon from '@mui/icons-material/Restore';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';


function VersionSelector({
                             options = [],           // Array von { code, displayName, … }
                             selectedRelease,
                             setSelectedRelease,
                         }) {
    const [anchorEl, setAnchorEl] = useState(null);
    const [tipOpen, setTipOpen]   = useState(false);
    const menuOpen = Boolean(anchorEl);

    const handleOpen = e => {
        if (options.length) setAnchorEl(e.currentTarget);
    };
    const handleClose = () => setAnchorEl(null);

    // aktuelles Objekt finden
    const current = options.find(v => v.code === selectedRelease.version);
    const label   = current?.displayName || 'Select Version';

    return (
        <>
            <Tooltip
                title="Choose Version"
                placement="bottom"
                open={tipOpen && !menuOpen}
                onOpen={() => setTipOpen(true)}
                onClose={() => setTipOpen(false)}
                disableFocusListener
                disableTouchListener
            >
                <Box
                    component="button"
                    type="button"
                    aria-label={`Choose Version: ${label}`}
                    onClick={(e) => { setTipOpen(false); handleOpen(e); }}
                    aria-haspopup="menu"
                    aria-expanded={menuOpen ? 'true' : undefined}
                    sx={{
                        color: 'inherit',
                        font: 'inherit',
                        background: 'transparent',
                        border: 0,
                        p: 0,
                        minWidth: { xs: 44, sm: 0 },
                        minHeight: { xs: 44, sm: 0 },
                        justifyContent: 'center',
                        display: 'flex',
                        alignItems: 'center',
                        cursor: options.length ? 'pointer' : 'default',
                        gap: 0.5
                    }}
                >
                    <RestoreIcon />
                    <Typography
                        variant="caption"
                        sx={{
                            display: { xs: 'none', lg: 'block' },
                            fontFamily: FONTS.body,
                            fontSize: '1rem',
                        }}
                    >
                        {label}
                    </Typography>
                    <ArrowDropDownIcon fontSize="small" />
                </Box>
            </Tooltip>

            <Menu anchorEl={anchorEl} open={menuOpen} onClose={handleClose}>
                {options.length === 0 && (
                    <MenuItem disabled sx={{ fontFamily: FONTS.body }}>
                        Keine Versionen verfügbar
                    </MenuItem>
                )}
                {options.map(v => (
                    <MenuItem
                        key={v.code}
                        onClick={() => {
                            setSelectedRelease(selectedRelease.with({ version: v.code }));
                            handleClose();
                        }}
                        sx={{ fontFamily: FONTS.body }}
                    >
                        {v.displayName}
                    </MenuItem>
                ))}
            </Menu>
        </>
    );
}

export default VersionSelector;

